/**
 * Barre de progression de la bannière Halloween.
 *
 * Le reste à atteindre dépend du panier, pas du produit : la bannière est
 * rendue en Liquid avec une barre à 0 %, et ce script la remplit.
 *
 * Deux sources selon l'emplacement :
 *  - fiche produit → le total du panier ;
 *  - builder       → le panier PLUS le pack en cours de composition, puisque
 *                    le palier porte sur le panier final. Le pack n'y est pas
 *                    encore, mais il va s'y ajouter.
 *
 * On relit /cart.js plutôt que de se fier au detail de cart:updated : le thème
 * l'émet depuis trois endroits avec trois charges utiles différentes (cartData,
 * un timestamp, ou rien).
 */
(() => {
  const SELECTEUR = '[data-hw-progress]';

  const formatter = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  });

  const formatMoney = cents => formatter.format(cents / 100);

  // Derniers états connus, conservés pour pouvoir recalculer la somme dès que
  // l'un des deux bouge.
  let panierCents = 0;
  let bundleCents = 0;

  const estDansBundle = bloc => Boolean(bloc.closest('bundle-section'));

  const totalPour = bloc => (estDansBundle(bloc) ? panierCents + bundleCents : panierCents);

  function peindre(bloc) {
    const cible = Number(bloc.dataset.hwProgressTarget) || 0;
    if (cible <= 0) return;

    const total = totalPour(bloc);
    const restant = Math.max(0, cible - total);
    const pourcent = Math.min(100, (total / cible) * 100);

    const fill = bloc.querySelector('[data-hw-progress-fill]');
    if (fill) fill.style.width = `${pourcent}%`;

    const atteint = restant === 0;
    const texte = bloc.querySelector('[data-hw-progress-remaining]');
    if (texte) {
      // Une fois le palier franchi, « Plus que 0,00 € » n'a aucun sens : on
      // bascule sur le message de réussite, réglé une fois pour toutes dans
      // les réglages du thème.
      const reussite = bloc.dataset.hwProgressReached;
      if (atteint && reussite) {
        texte.textContent = reussite;
      } else {
        const gabarit = bloc.dataset.hwProgressLabel || 'Plus que [amount]';
        texte.textContent = gabarit.replace('[amount]', formatMoney(restant));
      }
    }

    // Le total « /100€ » n'a plus de sens non plus une fois atteint.
    const totalAffiche = bloc.querySelector('.halloween-banner__progress-total');
    if (totalAffiche) totalAffiche.hidden = atteint && Boolean(bloc.dataset.hwProgressReached);

    // Permet de styler l'état atteint sans toucher au JS appelant.
    bloc.classList.toggle('is-reached', atteint);
  }

  const toutRepeindre = () => document.querySelectorAll(SELECTEUR).forEach(peindre);

  document.addEventListener('bundle:total-updated', e => {
    const total = e.detail?.totalCents;
    if (typeof total !== 'number') return;
    bundleCents = total;
    toutRepeindre();
  });

  // Le sidecart annonce son total à chaque mutation : on l'applique directement
  // plutôt que de relire /cart.js, qui serait en retard d'un tour.
  document.addEventListener('sidecart:total-updated', e => {
    const total = e.detail?.totalCents;
    if (typeof total !== 'number') return;
    panierCents = total;
    toutRepeindre();
  });

  async function relirePanier() {
    if (!document.querySelector(SELECTEUR)) return;
    try {
      const reponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!reponse.ok) return;
      const panier = await reponse.json();
      panierCents = panier.total_price || 0;
      toutRepeindre();
    } catch (e) {
      // Panier illisible : on laisse la barre dans son état rendu côté serveur.
    }
  }

  document.addEventListener('DOMContentLoaded', relirePanier);
  document.addEventListener('cart:updated', relirePanier);
  if (document.readyState !== 'loading') relirePanier();
})();
